"use client";

import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/use-is-mobile";
import Preloader from "@/components/global/Preloader";
import Hero from "@/components/public/home/hero";
import dynamic from "next/dynamic";
import { AnnouncementModal } from "@/components/public/home/announcement-modal";


// Lazy load below-the-fold components
const FeatureShowcase = dynamic(() => import("@/components/public/home/features-section"), {
    loading: () => <div className="w-full min-h-[500px] bg-slate-50 animate-pulse" />
});
const SVGMaskEffectDemo = dynamic(() => import("@/components/public/home/SVGMaskEffectDemo"), {
    loading: () => <div className="w-full min-h-[400px] bg-slate-50 animate-pulse" />
});
const KeyFeatures = dynamic(() => import("@/components/public/home/key-features"), {
    loading: () => <div className="w-full min-h-[600px] bg-slate-50 animate-pulse" />
});
const ComparisonSection = dynamic(() => import("@/components/public/home/comparison-section"), {
    loading: () => <div className="w-full min-h-[400px] bg-slate-50 animate-pulse" />
});
const WhoIsFor = dynamic(() => import("@/components/public/home/who-is-for"), {
    loading: () => <div className="w-full min-h-[800px] bg-slate-50 animate-pulse" />
});
const Testimonials = dynamic(() => import("@/components/public/home/testimonials"), {
    loading: () => <div className="w-full min-h-[400px] bg-slate-50 animate-pulse" />
});
const CreativeFloatingSection = dynamic(() => import("@/components/public/home/creative-section-tool"), {
    ssr: false // Client-only tool
});

export default function HomeClient() {
    const isMobile = useIsMobile();
    const [isLoading, setIsLoading] = useState(true);

    // On mobile, never show preloader. On desktop, show until Preloader calls onComplete.
    const showPreloader = isLoading && !isMobile;

    useEffect(() => {
        if (isMobile) {
            setIsLoading(false);
        }
    }, [isMobile]);


    return (
        <div className="w-full min-h-screen relative bg-white">
            {/* Content blurred only on desktop during preloader */}
            <div
                className={`transition-[filter] duration-500 ease-out will-change-[filter] ${showPreloader ? 'blur-xl' : 'blur-0'}`}
            >
                <div className="w-full min-h-screen relative">
                    <Hero />
                    <FeatureShowcase />
                    <SVGMaskEffectDemo />
                    <KeyFeatures />
                    <ComparisonSection />
                    <WhoIsFor />
                    <Testimonials />
                    <CreativeFloatingSection />
                    <AnnouncementModal isReady={!isLoading || isMobile} />


                </div>


            </div>

            {/* Preloader only on desktop */}
            {showPreloader && (
                <div className="fixed inset-0 z-[9999]">
                    <div className="w-full min-h-screen relative">
                        <Preloader onComplete={() => setIsLoading(false)} />
                    </div>
                </div>
            )}
        </div>
    );
}
